module.exports = __webpack_public_path__ + "img/group.045e1988.png";